/* eslint-disable no-console */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import AverageGrades from "./AverageGrades";
import TestPercentage from "./TestPercentage";
import AddTagsForm from "./AddTagsForm";

/**
 *
 * @param {Object} props.item a student object.
 * @returns a accordion where a user can click to expand and see more information.
 */
const Accordion = ({ item }) => {
  const [isOpen, setOpen] = useState(false);
  const [tags, setTags] = useState([]);

  return (
    <div className="info-container">
      <div className="fullname-icon-container">
        <span className="fullname-icon accordion__title">{`${item.firstName.toUpperCase()} ${item.lastName.toUpperCase()}`}</span>
        <span
          className={`fullname-icon accordion__icon ${isOpen ? "open" : ""}`}
          onClick={() => setOpen(!isOpen)}
        >
          {isOpen ? "-" : "+"}
        </span>
      </div>
      <p>Email: {item.email}</p>
      <p>Company: {item.company}</p>
      <p>Skill: {item.skill}</p>
      <AverageGrades grades={item.grades} />

      <div className="container__tag--margin">
        {tags.map((tag, index) => (
          <button key={tag} className="btn__tag">
            {tag}
          </button>
        ))}
      </div>

      <AddTagsForm tags={tags} setTags={setTags} />
      <TestPercentage grades={item.grades} isOpen={isOpen} />
    </div>
  );
};

export default Accordion;
